import { render } from "./d-card-result-view.vue?vue&type=template&id=5e954f7a&scoped=true&ts=true"
import script from "./d-card-result-view.vue?vue&type=script&lang=ts"
export * from "./d-card-result-view.vue?vue&type=script&lang=ts"

import "./d-card-result-view.vue?vue&type=style&index=0&id=5e954f7a&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e954f7a"]])

export default __exports__